<template>
  <div id="landing-page" class="d-flex flex-column justify-content-between">
    <div id="landing-container" class="mx-auto d-flex flex-column mb-5">
      <div
        id="login-contents"
        class="w-100 h-100 d-flex flex-column justify-content-between position-relative px-5 pb-5"
      >
        <div class="logo">
          <img
            :src="$whitelabel.assets.logos.large"
            alt="CrazyBuzzer Logo"
            style="width: 100%"
          />
        </div>
        <div class="herobanner">
          <img src="@/assets/img/logo/herobanner-cb.png" alt="Hero Banner" />
        </div>

        <LoginBox
          v-if="activeTab === 'login'"
          :error="loginError"
          @facebookConnected="handleFacebookLogin"
          @facebookLogout="handleFacebookLogout"
          @handleResetRequest="submitResetRequest"
          @stay="updateStayLoggedInPreference"
          @submitLogin="handleLogin"
          @toggle="handleTabtoggle('register')"
          @googleConnected="handleGoogleLogin"
        />
        <RegisterBox
          v-else
          :friend-referrer="$store.state.auth.referrerToken"
          :register-page-two="registerPageTwo"
          :error="registerError"
          @submitRegister="handleRegister"
          @facebookConnected="handleFacebookLogin"
          @facebookLogout="handleFacebookLogout"
          @page2="handleRegisterPageTwo"
          @back="handleBack"
          @toggle="handleTabtoggle('login')"
          @googleConnected="handleGoogleLogin"
        />
      </div>
      <AlertWindow />
    </div>
    <div style="max-width: 800px" class="mx-auto">
      <LegalRow />
    </div>
  </div>
</template>

<script>
import * as profileAPI from "@/API/profile.js";
import LoginBox from "@/components/landing/login-form.vue";
import LegalRow from "@/components/legal/legal-row.vue";
import RegisterBox from "@/components/landing/register-form.vue";
import AlertWindow from "@/components/base/alert-window.vue";
import checkLocale from "@/mixins/checkLocale.js";
import Bowser from "bowser";
import { getSettings } from "@/API/static-config";
import * as Cookies from "vue-cookies";

export default {
  name: "LandingPage",
  components: {
    LoginBox,
    RegisterBox,
    AlertWindow,
    LegalRow,
  },
  mixins: [checkLocale],
  data() {
    return {
      registerPageTwo: false,
      resetEmail: "",
      loginError: false,
      registerError: false,
      errorMessage: "",
      activeTab: "register",
      instantSlotId: null,
    };
  },
  computed: {
    lpBonusName() {
      return this.$store.state.auth.lpBonusName;
    },
    dynamicFontSize() {
      const text = this.$t("login.web.register.welcome_message");
      if (text.length > 40) {
        return "26px";
      } else {
        return "28px";
      }
    },
  },

  created: function () {
    this.checkLocale();
    let welcomeCookie = Cookies.get("welcome");
    if (
      this.$store.getters["cookieManager/isCookieSet"]("welcome") ||
      this.$route.query.token === "loginActive" ||
      welcomeCookie
    ) {
      this.activeTab = "login";
    }
  },

  mounted() {
    this.$store.commit("setIsPageLoading", false);

    if (!window._paypalHandled) {
      window._paypalHandled = true;

      const url = new URL(window.location.href);
      const paypalCode = url.searchParams.get("code");

      if (paypalCode) {
        this.$store
          .dispatch("auth/paypalLogin", paypalCode)
          .then((res) => {
            if (res.data.data.login) {
              this.$store.commit("auth/auth_success");
              if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
                this.googleTagLogAdvancedEvent({
                  event: "login",
                  method: "PayPal",
                });
              }
              this.playBackgroundMusic();
              this.safariRefresh();
              this.maybeRedirectToGame();
            } else {
              if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
                this.googleTagLogAdvancedEvent({
                  event: "sign_up",
                  method: "PayPal",
                });
              }

              this.proceedToLobby();
              this.requestEmailConfirm();
            }
          })
          .catch((err) => {
            console.error("PayPal login failed", err);
            this.displayErrorMessage?.();
          });
      }
    }

    //set instant slot value
    if (this.$store.getters["auth/isLoggedIn"]) {
      const userId = this.$store.getters["user/currentUser"].id;
    } else {
      getSettings().then((res) => {
        let gameIdFromLink = this.$store.state.gameplay.redirectGame;
        if (gameIdFromLink) {
          this.instantSlotId = gameIdFromLink;
          this.$store.commit("gameplay/setRedirectGame", null);
        } else {
          if (res.data && res.data["newuser.instant_slot"]) {
            this.instantSlotId = res.data["newuser.instant_slot"];

            //save setting config in store
            let configData = {};
            configData.settings = res.data;
            this.$store.commit("setGeneralConfig", configData);
          }
        }
      });
    }

    this.checkForLandingPageBonus();
  },
  methods: {
    async handleGoogleLogin(accessToken) {
      try {
        await this.$store
          .dispatch("auth/googleLogin", accessToken)
          .then((res) => {
            if (res.data.data.login) {
              this.$store.commit("auth/setReferrerToken", "");
              this.firebaseSetUser("GOOGLE");
              if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
                this.googleTagLogAdvancedEvent({
                  event: "login",
                  method: "Google",
                });
              }
              this.playBackgroundMusic();
              this.safariRefresh();
              this.maybeRedirectToGame();
            } else {
              if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
                this.googleTagLogAdvancedEvent({
                  event: "sign_up",
                  method: "Google",
                });
              }
              this.proceedToLobby();
            }
          });
      } catch (err) {
        console.log("Google login failed:", err);
        this.displayErrorMessage();
      }
    },
    checkForLandingPageBonus() {
      const lpName = this.$route.query.lp_redirect;
      if (lpName) {
        this.$store.commit("auth/setLpBonusName", lpName);

        //remove parameters from uri
        this.$router
          .replace(this.$route.fullPath.split("?")[0])
          .catch(() => {});
      }
    },
    handleLogin: function (email, password) {
      this.$store
        .dispatch("auth/logUserIn", { email, password })
        .then(() => {
          this.$store.commit("auth/setReferrerToken", "");
          this.$router.replace({ query: {} });
          this.firebaseSetUser("LEGACY");
          if (whitelabelConfig.featuresEnabled?.dataLayerTracking === true) {
            this.googleTagLogAdvancedEvent({
              event: "login",
            });
          }
          this.playBackgroundMusic();
          this.safariRefresh();
          this.maybeRedirectToGame();
        })
        .catch((err) => {
          if (err.data) {
            if (
              err.data.message ===
                "These credentials do not match our records." ||
              err.data.message ===
                "Dieses Konto existiert nicht oder die Daten wurden falsch eingegeben."
            ) {
              this.displayInvalidCredentialsMessage();
            } else {
              this.displayErrorMessage();
            }
          }
        });
    },
    handleFacebookLogin(oAuthToken) {
      this.$store
        .dispatch("auth/facebookLogin", oAuthToken)
        .then((res) => {
          if (res.data.data.login) {
            this.$store.commit("auth/auth_success");
            if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
              this.googleTagLogAdvancedEvent({
                event: "login",
                method: "Facebook",
              });
            }
            this.playBackgroundMusic();
            this.safariRefresh();
            this.maybeRedirectToGame();
          } else {
            if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
              this.googleTagLogAdvancedEvent({
                event: "sign_up",
                method: "Facebook",
              });
            }
            this.proceedToLobby();
            this.requestEmailConfirm();
          }
        })

        .catch((e) => {
          console.log(e);
          if (e.data.data.email) {
            this.$store.commit("popups/setAlertBannerContent", {
              alertText: e.data.data.email[0],
              type: "danger",
              variant: "danger",
              alertHeading: this.$t("alerts.title.error"),
            });
          } else {
            this.displayErrorMessage();
          }
        });
    },
    handleFacebookLogout() {
      this.$store.dispatch("destroyStore").then(this.$router.push("/"));
    },
    handleRegister(userData) {
      this.$store
        .dispatch("auth/registerUser", userData)
        .then(() => {
          this.proceedToLobby();
          this.$store.commit("auth/setReferrerToken", "");
          this.firebaseSetUser("LEGACY");
          if (this.$whitelabel.featuresEnabled.dataLayerTracking) {
            this.googleTagLogAdvancedEvent({
              event: "sign_up",
            });
          }
          let googleTagObj = {
            event: "Registrierung",
            label: "Web",
          };
          if (this.lpBonusName) {
            googleTagObj.exit_intent = this.lpBonusName;
          }
          this.googleTagLogAdvancedEvent(googleTagObj);
        })
        .then(() => {
          this.requestEmailConfirm();
        })
        .catch((e) => {
          this.registerError = true;
          console.log("ERROR", e);
          if (e.data.id) {
            if (e.data.id === "Validation failed") {
              if (e.data.details.email) {
                this.$store.commit("popups/setAlertBannerContent", {
                  alertText: e.data.details.email[0],
                  alertHeading: this.$t("alerts.title.error"),
                  type: "danger",
                  variant: "danger",
                });
              } else if (e.data.details.name) {
                this.$store.commit("popups/setAlertBannerContent", {
                  alertText: e.data.details.name[0],
                  alertHeading: this.$t("alerts.title.error"),
                  type: "danger",
                  variant: "danger",
                  dismissMessage: "ok-name-error",
                });
              } else {
                this.displayErrorMessage();
                console.log(e);
              }
            } else if (e.data.message) {
              this.$store.commit("popups/setAlertBannerContent", {
                alertText: e.data.message,
                alertHeading: this.$t("alerts.title.error"),
                type: "danger",
                variant: "danger",
              });
            }
          } else {
            this.displayErrorMessage();
          }
        });
    },
    proceedToLobby() {
      this.$store.commit("auth/auth_success");
      this.playBackgroundMusic();

      //go to instant slot, if available
      if (this.instantSlotId) {
        this.$router.push({
          name: "game",
          params: { gameId: this.instantSlotId },
        });
      } else if (this.$route.path === "/login") {
        this.$router.push("/");
      }
    },
    maybeRedirectToGame() {
      if (this.$store.state.gameplay.redirectGame) {
        let redirectGameId = parseInt(this.$store.state.gameplay.redirectGame);
        this.$router.push({
          name: "game",
          params: { gameId: redirectGameId },
        });
        this.$store.commit("gameplay/setRedirectGame", null);
      } else if (this.$route.path === "/login") {
        this.$router.push("/");
      } else return;
    },

    safariRefresh() {
      const browser = Bowser.getParser(window.navigator.userAgent).getBrowser()
        .name;
      if (browser === "Safari") {
        window.location.reload();
      }
    },
    requestEmailConfirm() {
      profileAPI.confirmEmail().catch((e) => console.log(e));
    },
    updateStayLoggedInPreference(boolean) {
      this.$store.commit("auth/setStayLoggedIn", boolean);
    },
    submitResetRequest(email) {
      this.resetEmail = email;
      profileAPI
        .requestReset(email)
        .then((res) => {
          this.$store.commit("popups/setAlertBannerContent", {
            alertText: this.$t("login.password_forgotten.reset_email_message", {
              0: this.resetEmail,
            }),
            alertHeading: "Ok!",
          });
        })
        .catch((e) => {
          console.log(e);
          if (e.data) {
            this.errorMessage = e.data.message;
            this.$store.commit("popups/setAlertBannerContent", {
              alertText: this.errorMessage,
              alertHeading: this.$t("alerts.title.error"),
              variant: "danger",
              type: "danger",
            });
          } else this.displayErrorMessage();
        });
    },
    handleRegisterPageTwo() {
      this.registerPageTwo = true;
    },
    handleBack() {
      this.registerPageTwo = false;
    },
    handleTabtoggle(tab) {
      this.activeTab = tab;
      if (tab === "login") {
        this.registerPageTwo = false;
      }
    },
  },
};
</script>
<style lang="scss">
#landing-page {
  #landing-container {
    overflow-y: auto;
    animation: fade 1s ease;
    background: linear-gradient(
      to bottom,
      #061625,
      #095a6b
    ); /* Gradient von oben nach unten */
    border: 4px solid #095a6b; /* Kontur in gewünschter Farbe */
    color: white;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    border-radius: 30px;
    font-size: 1rem;
    z-index: 2;
    max-width: 800px;
    width: 100%;
    padding: 0 1.5rem 2rem 1.5rem;
    margin: 1rem auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.5));
  }
  .logo {
    width: 90%;
    margin: 0 auto;
  }

  .logo img {
    display: block;
    margin: 0; /* <- entfernt vertikalen Abstand */
    padding: 0;
  }
  .herobanner {
    max-width: 630px;
    width: 100%;
    margin: 0 auto; /* Optional: stellt sicher, dass block zentriert bleibt */
  }

  .herobanner img {
    max-width: 630px;
    width: 100%;
    height: auto;
    display: block; /* verhindert unerwünschte Inline-Abstände */
  }
  form.landing-form-cb .form-control[type="email"],
  form.landing-form-cb .form-control[type="text"],
  form.landing-form-cb .form-control[type="password"] {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.6rem;
    border-radius: 100px;
    border: none;
    box-sizing: border-box;
    background-color: #22637b;
    color: #fff;
    background-image: none;
  }
  .form-link-cb {
    color: #8cc3d0 !important;
    text-decoration: underline !important;
  }

  .info-text {
    font-size: 16px;
    color: $text-gray;
  }

  .toggle-text {
    font-size: 21px;
    cursor: pointer;

    a {
      color: $text-accent !important;
      text-decoration: underline !important;
    }
  }

  .v-facebook-login {
    height: 48px;
    line-height: 1.1;
    background-color: #0d4aff;
    font-size: 16px;
    font-family: Ubuntu-Bold;
    text-transform: uppercase;
    cursor: pointer;
    min-width: 240px;
    border-radius: 100px;
  }

  .footnote {
    font-size: 9px;
    margin-top: 4rem;
    a {
      color: white !important;
      text-decoration: underline !important;
    }
  }
  .pseudo-label-cb {
    margin-left: 20.1px;
    font-size: 14px;
    font-family: Ubuntu;
    text-align: left;
    a {
      color: white;
      text-decoration: underline !important;
    }
  }

  form input:focus {
    outline: 2px solid #4ee5ff;
  }

  form input::-webkit-input-placeholder {
    color: #8cc3d0;
    text-indent: 5px;
    opacity: 1;
  }

  form input:-moz-placeholder {
    color: #8cc3d0;
    text-indent: 5px;
    opacity: 1;
  }

  form input:-ms-input-placeholder {
    color: #8cc3d0;
    text-indent: 5px;
    opacity: 1;
  }

  .checkbox-group {
    margin-top: 1rem;
    margin-left: 0;
    text-align: left;
    color: white;
    font-size: 0.8rem;
  }

  .checkbox-group label {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    cursor: pointer;
  }

  .checkbox-group input[type="checkbox"] {
    margin-right: 0.5rem;
    width: 18px;
    height: 18px;
  }

  .checkbox-group label span {
    display: inline;
    white-space: nowrap;
  }
}
// .dark.frc-captcha * {
//   color: rgba(255, 248, 183);
// }

// & {
//   .dark.frc-captcha {
//     color: #fff;
//     background-color: #081829;
//     border-color: #2edfea;
//   }
// }

// .dark.frc-captcha button {
//   background-color: #081829;
//   color: #2edfea;
// }
</style>
